{
  "name": "tef-coms",
  "version": "2.16.2",
  "title": "COMS Micro-Frontend",
  "description": "Micro-Frontend of the Consent Management System (COMS)",
  "author": {
    "name": "Telefónica Germany GmbH & Co. OHG",
    "email": "u672-coms@telefonica.com"
  },
  "license": "INTERNAL USE ONLY",
  "main": "dist/tef-coms-es5.js",
  "module": "dist/tef-coms.js",
  "types": "dist/typings.d.ts",
  "repository": {
    "type": "git",
    "url": "https://mucsggit02.sg.de.pri.o2.com/consent-management/consent-management.git",
    "directory": "micro-frontend"
  },
  "publishConfig": {
    "registry": "https://art02.sg.de.pri.o2.com/artifactory/api/npm/npm-local/"
  },
  "files": [
    "dist/**/*"
  ],
  "keywords": [
    "tef-coms",
    "coms",
    "micro-frontend",
    "web component"
  ],
  "scripts": {
    "install:ci": "npm ci",
    "dev": "esbuild src/tef-coms.ts --servedir=public --serve=4400 --outdir=public --bundle",
    "build": "npm run build:ts && npm run build:doc && npm run build:copy",
    "build:ts": "ts-node ./scripts/build.ts",
    "build:doc": "ts-node scripts/create-user-doc.ts",
    "build:copy": "cp public/* dist && cp src/types/typings.d.ts dist",
    "build:serve": "npm run build && npx -y serve -l 4400 dist",
    "lint": "eslint . --ignore-path ./.eslintignore",
    "test": "npm run test:browser && npm run test:unit",
    "test:browser": "web-test-runner",
    "test:unit": "jest",
    "test:all": "npm run lint && npm run build:ts && npm test",
    "test:ci": "npm run lint && CI=true npm test",
    "test:ci-reduced": "npm run lint && CI=true npm test",
    "preversion": "npm run lint && npm test"
  },
  "dependencies": {
    "lit": "^2.7.5",
    "nanoid": "^3.3.2",
    "pwa-helpers": "^0.9.1",
    "redux": "^4.2.1",
    "redux-thunk": "^2.4.2",
    "regenerator-runtime": "^0.13.11",
    "ts-node": "^10.9.1",
    "unfetch": "^5.0.0"
  },
  "devDependencies": {
    "@open-wc/testing": "^3.2.0",
    "@rollup/plugin-replace": "^5.0.2",
    "@types/jest": "^29.5.2",
    "@types/jsonwebtoken": "^9.0.2",
    "@types/markdown-it-attrs": "^4.1.0",
    "@types/markdown-it-container": "^2.0.5",
    "@types/markdown-it-emoji": "^2.0.2",
    "@types/mustache": "^4.2.2",
    "@web/dev-server-esbuild": "^0.4.1",
    "@web/test-runner": "^0.16.1",
    "@web/test-runner-puppeteer": "^0.11.0",
    "chai": "^4.3.7",
    "chai-as-promised": "^7.1.1",
    "esbuild": "^0.18.11",
    "eslint": "^8.43.0",
    "eslint-config-airbnb-typescript": "^17.0.0",
    "eslint-plugin-lit": "^1.8.3",
    "eslint-plugin-should-promised": "^2.0.0",
    "fetch-mock": "^9.10.7",
    "finalhandler": "^1.2.0",
    "jest": "^29.5.0",
    "jsdom": "^22.1.0",
    "jsonwebtoken": "^9.0.0",
    "markdown-it": "^13.0.1",
    "markdown-it-anchor": "^8.6.7",
    "markdown-it-attrs": "^4.1.6",
    "markdown-it-container": "^3.0.0",
    "markdown-it-emoji": "^2.0.2",
    "markdown-it-toc-done-right": "^4.1.0",
    "mdn-polyfills": "^5.20.0",
    "mustache": "^4.2.0",
    "puppeteer": "^20.7.3",
    "redux-mock-store": "^1.5.4",
    "sinon": "^15.2.0",
    "sinon-chai": "^3.7.0",
    "ts-jest": "^29.1.0",
    "typescript": "^5.1.3"
  }
}
